'use strict';

/**
 *
 * @param {*} result
 * @param {*} callback
 */
window.capency = {};

let dataSearchStreet = {};
let paramDataSearchStreet = {};
const callWebService = require('capency/capency/address/serverActions/callWebService');
const capencyHelper = require('capency/capencyHelper');

/**
* Displays the Capency address verification result and handles user interaction with the suggested addresses.
*
* @param {Object} result - The result object from the Capency address verification service.
* @param {string} result.step - The current step of the verification process.
* @param {string} result.falseAddresse - The message to display for the current address.
* @param {Array} result.addresses - A list of suggested addresses.
* @param {Function} callback - A callback function to execute after the address verification process.
*/
async function showCapencyVerifyResult(result, callback) {
    if (result.step === 'forced') {
        let $falseAddressElm = $('<li>');
        let $falseInputElm = $('<input>', {
            id: 'falseAddress',
            name: 'capSuggestedAddress',
            class: 'capency-false-suggested-address',
            type: 'radio',
            value: result.falseAddress,
            'data-item': JSON.stringify(result.falseAddress),
            'data-address-streetName': result.address,
            checked: true
        });

        let falseAddressLabel = $('<label>', {
            for: 'falseAddress',
            text: result.address + ', ' + result.zip + ' ' + result.city
        });

        $falseAddressElm.append($falseInputElm).append(falseAddressLabel);
        $('.current-address-title').find('li').empty().append($falseAddressElm);

        $('.address-list-sugression').find('ul').empty();
        $.each(result.addresses, function (i, address) {
            if (address.additionalInfo_1 && address.additionalInfo_2) {
                var $suggestedAddressElm = $('<li>');
                var $inputElm = $('<input>', {
                    id: 'suggestion-address' + i,
                    name: 'capSuggestedAddress',
                    class: 'capency-suggested-address',
                    type: 'radio',
                    value: address.additionalInfo_1,
                    'data-item': JSON.stringify(address),
                    'data-address-streetName': address.streetName,
                    'data-qualityCode': address.qualityCode,
                    'data-address-streetNumber': address.streetNumber
                });

                let text = '';
                if (address.buildingName) {
                    text = address.buildingName + ' - ';
                }
                text += address.additionalInfo_1 + ', ' + address.additionalInfo_2;

                var addressLabel = $('<label>', {
                    for: 'suggestion-address' + i,
                    text
                });

                $suggestedAddressElm.append($inputElm).append(addressLabel);
                $('.address-list-sugression').find('ul').append($suggestedAddressElm);
            }
        });

        $('#verifyAddresseModel').modal('show');
        $.spinner().stop();

        let searchResult = await capencySearchAddress();
        let message = searchResult.message;

        $('#addressFoundMessage').text(`${message}`);

        $('#verifyAddresseModel').find('.btn-primary').off('click').on('click', function () {
            var radioValue = $("input[name='capSuggestedAddress']:checked").val();
            var streetNumber = $("input[name='capSuggestedAddress']:checked").next().find('select').val();
            var qualityCode = $("input[name='capSuggestedAddress']:checked").attr('data-qualityCode');
            let $address = $('input[name$="_address1"]');
            let $building = $('input[name$="_address2"]');
            let $city = $('input[name$="_city"]');
            let $zipCode = $('input[name$="_postalCode"]');

            if (typeof streetNumber === 'undefined') {
                streetNumber = $("input[name='capSuggestedAddress']:checked").attr('data-address-streetNumber');
            }

            if (radioValue) {
                if ($('input[name$="_address1"]').length) {
                    $('input[name$="_address1"]').empty().val((streetNumber && streetNumber !== '' ? streetNumber + ' ' : '') + $("input[name='capSuggestedAddress']:checked").attr('data-address-streetName'));
                    $zipCode.toggleClass('autocomplete-field-selected', true);
                    $city.toggleClass('autocomplete-field-selected', true);
                    $address.toggleClass('autocomplete-field-selected', true);

                    if (qualityCode === '10') {
                        $('input[name$="_address1"]').attr('data-address-force', true);
                    }

                    // update selected address street number and delete list streets if exists
                    var selectedAddress = JSON.parse($("input[name='capSuggestedAddress']:checked").attr('data-item'));
                    selectedAddress.streetNumber = streetNumber;
                    if (selectedAddress.locality && selectedAddress.postalCode) {
                        $city.val(selectedAddress.locality);
                        $zipCode.val(selectedAddress.postalCode);
                    }
                    delete selectedAddress.listStreetNumber;
                    $("input[name='capSuggestedAddress']:checked").attr('data-item', JSON.stringify(selectedAddress));
                } else {
                    $('input[name$="_addressFields_address1"]').empty().val((streetNumber && streetNumber !== '' ? streetNumber + ' ' : '') + $("input[name='capSuggestedAddress']:checked").attr('data-address-streetName'));
                }
            } else {
                $('input[name$="_address1"]').attr('data-address-force', true);
            }

            const dataItem = JSON.parse($("input[name='capSuggestedAddress']:checked").attr('data-item'));
            if (dataItem) {
                if (dataItem.postalCode) {
                    $zipCode.val(dataItem.postalCode);
                }
                if (dataItem.locality) {
                    $city.val(dataItem.locality);
                }
                if (dataItem.buildingName) {
                    $building.val(dataItem.buildingName);
                }
            }

            if ($zipCode.val() && $city.val() && $address.val()) {
                capencyHelper.fillZipCodeWithAllCapData($zipCode, selectedAddress);
            }

            $('#verifyAddresseModel').modal('hide');
            $.spinner().stop();
            if (callback) {
                callback();
            }
        });

        $('#verifyAddresseModel').find('.btn-secondary').off('click').on('click', function () {
            $('#verifyAddresseModel').modal('hide');
            $.spinner().stop();
            if (callback) {
                callback();
            }
        });

        $('#verifyAddresseModel').find('.close').off('click').on('click', function () {
            $('#verifyAddresseModel').modal('hide');
            $.spinner().stop();
            return false;
        });

        $("input[name='capSuggestedAddress']:radio").next().find('select').each(function () {
            var $mainElement = $(this);
            $mainElement.change(function () {
                $(this).parents().find("input[name='capSuggestedAddress']").click();
            });
        });
    }
}

/**
* Handles the scenario where an address verification fails, prompting the user to either keep the address or correct it.
*
* This function highlights the address fields as invalid and displays a modal with options for the user to either keep the address or correct it.
*
* @returns {Promise<string>} - A promise that resolves to 'keep-address' if the user chooses to keep the address, or rejects with 'correct-address' if the user chooses to correct it.
*/
function capencyKeepAddress() {
    const $modalError = $('.login').length ? $('#verifyAddresseError') : $('#verifyAddressBookError');
    const $address = $('input[name$="_address1"]');
    const $city = $('input[name$="_city"]');
    const $zipCode = $('input[name$="_postalCode"]');
    const elements = [$zipCode, $city, $address];

    elements.forEach($el => {
        $el.toggleClass('autocomplete-field-selected', false).addClass('is-invalid');
    });

    $modalError.modal('show');

    return new Promise((resolve, reject) => {
        $('.btn-keep-address').one('click', function () {
            $modalError.modal('hide');
            resolve('keep-address');
        });

        $('.btn-correct-address').one('click', function () {
            $modalError.modal('hide');
            $('.banner-message').removeClass('d-none');
            reject(new Error('correct-address'));
        });
    });
}

/**
* Prepares and returns data for searching street addresses based on the current city and zip code.
*
* @param {string} currentCity - The current city to be included in the search.
* @param {string} currentZip - The current zip code to be included in the search.
* @returns {Object|null} The prepared data for searching street addresses, or null if no search data is available.
*/
function prepareDataSearchStreet(currentCity, currentZip) {
    let $addressSelector = $('[name="dwfrm_address_address1"]').length ? $('[name="dwfrm_address_address1"]') : $('[name="dwfrm_shippingAddress_address1"]');
    let $currentCountry = $('#country');
    let additionalOutput = '';
    dataSearchStreet = null;

    let currentAddress = $addressSelector.val();

    if (!currentAddress && $addressSelector.length > 1) {
        currentAddress = $($addressSelector[1]).val();
    }

    if (paramDataSearchStreet) {
        additionalOutput = [currentCity, currentZip].filter(Boolean).join(' ') + ' ';
        paramDataSearchStreet.inputOutput = additionalOutput + currentAddress;
        paramDataSearchStreet.currentCountry = $currentCountry.val();
        dataSearchStreet = paramDataSearchStreet;
    }
    return dataSearchStreet;
}

/**
* Searches for an address using the provided city and postal code, and determines the next step in the address verification process.
*
* This function interacts with the DOM to retrieve the current values of the address, city, and postal code fields from a registration form.
* It checks if all fields have been selected using an autocomplete feature and prepares data for a street search.
* The search result is then used to construct an object containing the next step in the process and relevant address information.
*
* @returns {Object} An object containing:
* - `step` {string}: Indicates the next step in the process, either 'validateForm' if all fields are selected or 'forced' otherwise.
* - `address` {string}: The current value of the address field.
* - `addresses` {Array}: A list of addresses returned from the search result.
* - `city` {string}: The current value of the city field.
* - `zip` {string}: The current value of the postal code field.
* - `falseAddress` {Object}: The data used for searching the street, which may be used for further validation.
*/
async function capencySearchAddress() {
    const addressDetails = getRightAddress();

    dataSearchStreet = prepareDataSearchStreet(addressDetails.currentCity, addressDetails.currentZip);
    const searchResult = await callWebService.SearchStreet(dataSearchStreet);

    return {
        step: addressDetails.allSelected ? 'validateForm' : 'forced',
        address: addressDetails.currentAddress,
        addresses: searchResult.addresses,
        message: searchResult.message,
        city: addressDetails.currentCity,
        zip: addressDetails.currentZip,
        falseAddress: dataSearchStreet,
        capencyNotResponding: searchResult.capencyNotResponding
    };
}

/**
* Handles the address verification process based on the verification result.
*
* This function processes the result of an address verification step. If the step is 'forced',
* it checks if the addresses are undefined and handles the verification accordingly. It either
* keeps the address or prompts the user to correct it. If the step is not 'forced', it resolves
* the promise immediately with a value of true.
*
* @param {Object} result - The result object from the address verification process.
* @param {string} result.step - The current step of the address verification process.
* @param {Array|undefined} result.addresses - The list of addresses returned from the verification, if any.
* @returns {Promise<boolean>} - A promise that resolves to true if the address is kept or the process completes successfully, and false if the address needs correction.
*/
async function handleAddressVerification(result) {
    let $errorMessage = $('.login').length ? $('#verifyAddresseErrorMessage') : $('#verifyAddressBookErrorMessage');
    let message = result.message;
    let $address = $('input[name$="_address1"]');

    const addressDetails = getRightAddress();
    const isAddressFilled = addressDetails.currentCity.length > 0 || addressDetails.currentZip.length > 0 || addressDetails.currentCity.length > 0;

    const allUndef = result.addresses ? result.addresses.every((address) => !address.additionalInfo_1 || !address.additionalInfo_2) : false;

    if (result.step === 'forced' && !allUndef && isAddressFilled && !result.capencyNotResponding) {
        if (result.addresses === undefined) {
            return capencyKeepAddress(result)
                .then((value) => value === 'keep-address')
                .catch((value) => {
                    if (value.message === 'correct-address') {
                        $address.focus();
                        if ($errorMessage.is('#verifyAddressBookErrorMessage')) {
                            $('.error-message-required').text(`${message}`);
                            $('#verifyAddressBookErrorMessage').removeClass('d-none');
                        } else {
                            $('#verifyAddresseErrorMessage').removeClass('d-none');
                        }
                    }
                    return false;
                });
        }

        return new Promise((resolve) => {
            $.spinner().start();
            showCapencyVerifyResult(result, function () {
                $.spinner().stop();
                capencyValidateForm();
                capencyHelper.resetModifiedFlagOnAddressFields();
                resolve(true);
            });
        });
    }
    if (!allUndef && isAddressFilled) {
        capencyValidateForm();
        capencyHelper.resetModifiedFlagOnAddressFields();
    }
    return Promise.resolve(true);
}

/**
* Asynchronously verifies an address using the Capency service.
*
* This function attempts to verify an address by first searching for it using the
* `capencyVerfiyAddress.capencySearchAddress` method. If the Capency address verification
* feature is enabled, it proceeds to handle the address verification process.
* @async
* @returns {Promise<boolean>} - Returns a promise that resolves to `false` if an error occurs
* during the address verification process. If no error occurs, the function does not explicitly
* return a value.
*/
async function capencyCheckAddress() {
    try {
        if (!capencyHelper.isAddressFormModified()) {
            return true;
        }

        let result = await capencySearchAddress();
        if (capencyHelper.isCapencyEnabled('address')) {
            let isVerified = await handleAddressVerification(result);
            return isVerified;
        }
        return true;
    } catch (error) {
        console.error('Error during address verification:', error);
        return false;
    }
}

async function capencyValidateForm() {
    const data = $('input[name$="_postalCode"].autocomplete-field-selected').attr('data-address');
    if (data) {
        const validationParams = JSON.parse(data);
        validationParams.step = 'ValidateForm';

        return callWebService.ValidationForm(validationParams);
    }
    return Promise.resolve(true);
}

/**
* Retrieves the current address details from the form fields on the page.
* This function checks for the presence of address, city, and postal code fields
* and returns their values. If multiple fields are present, it attempts to use
* the second field's value if the first is empty.
*
* @returns {Object} An object containing the current address details:
* - {string} currentAddress - The current street address.
* - {string} currentZip - The current postal code.
* - {string} currentCity - The current city.
* - {string} currentCity - allSelected - A boolean indicating whether all relevant fields are selected.
*/
function getRightAddress() {
    let $addressSelector = $('[name="dwfrm_address_address1"]').length ? $('[name="dwfrm_address_address1"]') : $('[name="dwfrm_shippingAddress_address1"]');
    let $citySelector = $('[name="dwfrm_address_city"]').length ? $('[name="dwfrm_address_city"]') : $('[name="dwfrm_shippingAddress_city"]');
    let $postalCodeSelector = $('[name="dwfrm_address_postalCode"]').length ? $('[name="dwfrm_address_postalCode"]') : $('[name="dwfrm_shippingAddress_postalCode"]');

    let currentCity = $citySelector.val();
    let currentZip = $postalCodeSelector.val();
    let currentAddress = $addressSelector.val();
    if ($citySelector.length > 1) {
        currentCity = $($citySelector[1]).val();
    }
    if ($postalCodeSelector.length > 1) {
        currentZip = $($postalCodeSelector[1]).val();
    }
    if ($addressSelector.length > 1) {
        currentAddress = $($addressSelector[1]).val();
    }
    let allSelected = $addressSelector.hasClass('autocomplete-field-selected')
                && $citySelector.hasClass('autocomplete-field-selected')
                && $postalCodeSelector.hasClass('autocomplete-field-selected');
    return {
        currentAddress: currentAddress,
        currentZip: currentZip,
        currentCity: currentCity,
        allSelected: allSelected
    };
}

$(document).ready(function () {
    $('input[name$="_address1"]').attr('data-address-force', false);

    $('#verifyAddresseModel').on('hide.bs.modal', function () {
        $.spinner().stop();
    });

    $('.btn-save-verfiyAddress').on('click', function () {
        $('input[name$="_address1"]').attr('data-address-force', true);
        $('#verifyAddresseError').modal('hide');
    });

    $('.billing-address-block').find('.btn-add-new').on('click', function () {
        $('.billing-address-block').find('input[name$="_address1"]').val('').attr('disabled', true);
        $('.billing-address-block').find('input[name$="_address2"]').val('').attr('disabled', true);
    });
});

/**
* Validates and applies a specific CSS class to registered address input fields.
* This function selects the address, city, and postal code input fields and
* toggles the 'autocomplete-field-selected' class on each of them, indicating
* that these fields are part of an address validation process.
*
* @function
* @returns {void} This function does not return a value.
*/
function validateRegisteredAddress() {
    let $address = $('input[name$="_address1"]');
    let $city = $('input[name$="_city"]');
    let $zipCode = $('input[name$="_postalCode"]');

    $zipCode.toggleClass('autocomplete-field-selected', true);
    $city.toggleClass('autocomplete-field-selected', true);
    $address.toggleClass('autocomplete-field-selected', true);
}

/**
* Resets the validation state of registered address fields by removing the 'autocomplete-field-selected' class.
* This function targets specific input fields for address, city, and postal code, and ensures they are not marked
* as selected by the autocomplete feature.
*
* @function
* @returns {void}
*/
function invalidateRegisteredAddress() {
    let $address = $('input[name$="_address1"]');
    let $city = $('input[name$="_city"]');
    let $zipCode = $('input[name$="_postalCode"]');

    $zipCode.toggleClass('autocomplete-field-selected', false);
    $city.toggleClass('autocomplete-field-selected', false);
    $address.toggleClass('autocomplete-field-selected', false);
}

module.exports = {
    showCapencyVerifyResult: showCapencyVerifyResult,
    capencyKeepAddress: capencyKeepAddress,
    prepareDataSearchStreet: prepareDataSearchStreet,
    capencySearchAddress: capencySearchAddress,
    handleAddressVerification: handleAddressVerification,
    capencyCheckAddress: capencyCheckAddress,
    validateRegisteredAddress: validateRegisteredAddress,
    capencyValidateForm: capencyValidateForm,
    invalidateRegisteredAddress: invalidateRegisteredAddress
};
